import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import { affiliateRoute } from '.'

const Affiliate = lazyRouteComponent(
  () => import('../../../pages/profile/affiliate/affiliate'),
)

export const affiliateIndexRoute = createRoute({
  getParentRoute: () => affiliateRoute,
  path: '/',
  component: Affiliate,
})
